import { configureStore, Store } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist'

import rootSaga from './modules/rootSaga'
import { AuthState } from './modules/auth/types'
import { MenuState } from './modules/menu/types'
import { CercState } from './modules/cerc/types'

import { persistedReducers } from './modules/reduxPersist'


export interface StoreState {
    auth: AuthState,
    menu: MenuState,
    cerc: CercState
}


const sagaMiddleware = createSagaMiddleware()
const store: Store<StoreState> = configureStore({
    reducer: persistedReducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
        }
    }).concat(sagaMiddleware)
})

sagaMiddleware.run(rootSaga)

export const persistor = persistStore(store)
export default store